// [src/pages/Payment/PaymentCancel.jsx]

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

function PaymentCancel() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // URL 이동 헬퍼 함수
    const getTargetUrl = () => {
        const brKey = searchParams.get('brKey') || new URLSearchParams(window.location.search).get('brKey');
        return brKey ? `hypehaus://prod/${brKey}` : "hypehaus://home";
    };

    // 페이지 진입 시 상태 확인
    useEffect(() => {
        const code = searchParams.get('code');
        const message = searchParams.get('message');

        // [방어 로직] 취소 페이지로 에러 코드가 넘어왔다면 실패 페이지로 이동
        // (단순 취소가 아니라 시스템 에러인 경우를 대비)
        if (code && code !== '') {
            console.warn(`❌ [PaymentCancel] 비정상 취소 코드 감지 (Code: ${code})`);
            navigate('/payment/fail', {
                state: {
                    code: code,
                    message: message || '결제 취소 중 오류가 발생했습니다.'
                },
                replace: true
            });
            return;
        }

    }, [searchParams, navigate]);

    // 수동 버튼 클릭 핸들러
    const handleGoBack = () => {
        window.location.href = getTargetUrl();
        setTimeout(() => window.location.replace('/'), 500);
    };

    return (
        <div style={staticStyles.backgroundWrapper}>
            <main style={staticStyles.mainContent}>
                <div style={staticStyles.messageSection}>
                    <div style={staticStyles.iconWrapper}>
                        <div style={staticStyles.closeIcon} />
                    </div>
                    <h2 style={staticStyles.title}>결제가 취소되었습니다</h2>
                    <p style={staticStyles.description}>
                        사용자 요청에 의해<br />
                        결제가 중단되었습니다.
                    </p>
                </div>

                <div style={staticStyles.infoBox}>
                    <p style={staticStyles.infoText}>
                        결제 과정에서 문제가 발생했거나<br />
                        사용자에 의해 중단되었습니다.<br />
                        계좌에서 출금되지 않았으니 안심하세요.
                    </p>
                </div>
            </main>

            <div style={staticStyles.bottomButtonWrapper}>
                <button style={staticStyles.confirmButton} onClick={handleGoBack}>
                    홈으로 돌아가기
                </button>
            </div>
        </div>
    );
}

/** @type {React.CSSProperties} */
const staticStyles = {
    backgroundWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#0D042D',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        margin: '0 auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        zIndex: 1
    },
    mainContent: {
        flex: 1,
        overflowY: 'auto',
        paddingTop: 'calc(env(safe-area-inset-top, 47px) + 50px)',
        paddingBottom: '100px',
        paddingLeft: '24px',
        paddingRight: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    messageSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '40px'
    },
    iconWrapper: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'rgba(255, 82, 82, 0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '24px'
    },
    closeIcon: {
        width: '24px',
        height: '24px',
        background: `linear-gradient(45deg, transparent 44%, #FF5252 44%, #FF5252 56%, transparent 56%), linear-gradient(-45deg, transparent 44%, #FF5252 44%, #FF5252 56%, transparent 56%)`
    },
    title: { fontFamily: 'Pretendard', fontWeight: '700', fontSize: '24px', color: '#FCFCFA', margin: '0 0 12px 0' },
    description: {
        fontFamily: 'Pretendard',
        fontWeight: '400',
        fontSize: '16px',
        color: '#9A9A9A',
        lineHeight: '1.5',
        margin: 0
    },
    infoBox: {
        width: '100%',
        backgroundColor: '#1B1931',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    },
    infoText: {
        fontFamily: 'Pretendard',
        fontWeight: '500',
        fontSize: '14px',
        color: '#747474',
        lineHeight: '1.6',
        margin: 0
    },
    bottomButtonWrapper: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '24px 24px calc(env(safe-area-inset-bottom, 24px) + 24px)',
        boxSizing: 'border-box',
        backgroundColor: '#0D042D',
        zIndex: 100
    },
    confirmButton: {
        width: '100%',
        height: '56px',
        border: 'none',
        borderRadius: '8px',
        background: '#3A394A',
        cursor: 'pointer',
        fontFamily: 'Pretendard',
        fontWeight: '700',
        fontSize: '16px',
        color: '#FFFFFF'
    },
};

export default PaymentCancel;